<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AHqf21/tc-custom/9780253018731.jpg?1724535469416" alt="This image is the cover for the book Geopolitics and the Quest for Dominance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Geopolitics and the Quest for Dominance
      </h1>
      <p class="bookDescription body article font2">
        <p>History and geography delineate the operation of power, not only its range but also the capacity to plan and the ability to implement. Approaching state strategy and policy from the spatial angle, Jeremy Black argues that just as the perception of power is central to issues of power, so place, and its constraints and relationships, is partly a matter of perception, not merely map coordinates. Geopolitics, he maintains, is as much about ideas and perception as it is about the actual spatial dimensions of power. Black's study ranges widely, examining geography and the spatial nature of state power from the 15th century to the present day. He considers the rise of British power, geopolitics and the age of Imperialism, the Nazis and World War II, and the Cold War, and he looks at the key theorists of the latter 20th century, including Henry Kissinger, Francis Fukuyama and Samuel P. Huntington, Philip Bobbitt, Niall Ferguson, and others.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeremy Black
      </h2>
      
      <p class="authorDescription body article"><P>Jeremy Black is Professor of History at the University of Exeter. He is author of many books including Other Pasts, Different Presents, Alternative Futures (IUP, 2015); Clio's Battles: Historiography in Practice (IUP, 2015); The Power of Knowledge: How Information and Technology Made the Modern World; War and Technology (IUP, 2013); and Fighting for America: The Struggle for Mastery in North America, 1519-1871 (IUP, 2011). </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19292194